window.initTooltips = function() {
  // For each .tooltip-container
  const tooltipContainers = document.querySelectorAll(".tooltip-container");
  
  tooltipContainers.forEach((container) => {
    const tooltipTrigger = container.querySelector(".tooltip-trigger");
    const tooltipContent = container.querySelector(".tooltip-content");

    tooltipTrigger.addEventListener("mouseover", () => {
      tooltipContent.style.display = "block";
    });
    container.addEventListener("mouseover", () => {
      tooltipContent.style.display = "block";
    });
    container.addEventListener("mouseout", () => {
      tooltipContent.style.display = "none";
    });
  });
};
